module.exports = __webpack_public_path__ + "static/media/ball2.46dbff9e.png";